// View payment
// MonthlyPayment
import MainPaymentsPage from '~user-pages/Reports/Payments/MainPayments'
import MonthlyPayment from '~user-pages/Reports/Payments/MonthlyPayment'
import WarehousingFees from '~user-pages/Reports/Payments/WarehousingFees'
import Refunds from '~user-pages/Reports/Payments/Refunds'
import Invoices from '~user-pages/Reports/Payments/Invoices'

import FulfillmentReport from '~user-pages/Reports/FulfillmentReport'

import MainInventoryReport from '~user-pages/Reports/InventoryRreport/MainInventoryReport'
import InventoryAge from '~user-pages/Reports/InventoryRreport/InventoryAge'
import InventoryReserved from '~user-pages/Reports/InventoryRreport/InventoryReserved'
import InventoryReconciliation from '~user-pages/Reports/InventoryRreport/InventoryReconciliation'
import InventoryExcess from '~user-pages/Reports/InventoryRreport/InventoryExcess'
import RecommendedRemoval from '~user-pages/Reports/InventoryRreport/RecommendedRemoval'
import RemovalPlansShipments from '~user-pages/Reports/InventoryRreport/RemovalPlansShipments'

import BusinessSalesReport from '~user-pages/Reports/BusinessSalesReport'

export default [
    {
        path: 'payments',
        name: 'Payments',
        component: MainPaymentsPage,
        redirect: {name: 'MonthlyPayment'},
        meta: {
            breadcrumb: {
                text: 'Payments'
            }
        },
        children: [
            {
                path: 'monthly-payment-table',
                name: 'MonthlyPayment',
                component: MonthlyPayment,
                meta: {
                    breadcrumb: {
                        text: 'Monthly payment table'
                    }
                },
            },
            {
                path: 'warehousing-fees',
                name: 'WarehousingFees',
                component: WarehousingFees,
                meta: {
                    breadcrumb: {
                        text: 'Warehousing (storage) fees'
                    }
                },
            },
            {
                path: 'refunds',
                name: 'Refunds',
                component: Refunds,
                meta: {
                    breadcrumb: {
                        text: 'Refunds'
                    }
                },
            },
            {
                path: 'invoices',
                name: 'Invoices',
                component: Invoices,
                meta: {
                    breadcrumb: {
                        text: 'Invoices'
                    }
                },
            },
        ]
    },
    {
        path: 'fulfillment-report',
        name: 'FulfillmentReport',
        component: FulfillmentReport,
        meta: {
            breadcrumb: {
                text: 'Fulfillment Report'
            }
        },
    },
    {
        path: 'inventory-report',
        name: 'InventoryReport',
        component: MainInventoryReport,
        redirect: {name: 'InventoryAge'},
        meta: {
            breadcrumb: {
                text: 'Inventory report'
            }
        },
        children: [
            {
                path: 'inventory-age',
                name: 'InventoryAge',
                component: InventoryAge,
                meta: {
                    breadcrumb: {
                        text: 'Inventory Age'
                    }
                },
            },
            {
                path: 'inventory-reserved',
                name: 'InventoryReserved',
                component: InventoryReserved,
                meta: {
                    breadcrumb: {
                        text: 'Inventory Reserved'
                    }
                },
            },
            {
                path: 'inventory-reconciliation',
                name: 'InventoryReconciliation',
                component: InventoryReconciliation,
                meta: {
                    breadcrumb: {
                        text: 'Inventory Reconciliation'
                    }
                },
            },
            {
                path: 'inventory-excess',
                name: 'InventoryExcess',
                component: InventoryExcess,
                meta: {
                    breadcrumb: {
                        text: 'Inventory Excess'
                    }
                },
            },
            {
                path: 'recommended-removal',
                name: 'RecommendedRemoval',
                component: RecommendedRemoval,
                meta: {
                    breadcrumb: {
                        text: 'Recommended removal'
                    }
                },
            },
            {
                path: 'removal-plans-and-shipments',
                name: 'RemovalPlansShipments',
                component: RemovalPlansShipments,
                meta: {
                    breadcrumb: {
                        text: 'Removal plans and shipments'
                    }
                },
            },
        ]
    },
    {
        path: 'business-sales-report',
        name: 'BusinessSalesReport',
        component: BusinessSalesReport,
        meta: {
            breadcrumb: {
                text: 'Business/sales Report'
            }
        },
    },
]



// WEBPACK FOOTER //
// ./src/router/modules/reports-routes.js